import API from "./baseApi";

const createGenericProducts = (payload) => {
    return API.post("products/createGenericProducts", payload);
};

const getGenericProducts = (payload) => {
    return API.post("products/getGenericProducts", payload);
};

const updateGenericProducts = (payload) => {
    return API.post("products/updateGenericProducts", payload);
};

const getProductConfig = (payload) => {
    return API.get("products/getProductConfig", payload);
};

const createProductConfig = (payload) => {
    return API.post("products/createProductConfig", payload);
};


export default {
    createGenericProducts,
    getGenericProducts,
    updateGenericProducts,
    getProductConfig,
    createProductConfig,
};
